import moment from "moment"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormTypes from "../Types/DynamicFormsTypes"
import FieldTypes from "../Types/FieldTypes"
import paletteEngine from "./paletteEngine"
import schemaBoiler from "./SchemaBoiler"
import FieldSchemaTypes from "../Types/FieldSchemaTypes"
import snackBar from "src/utilities/snackBar/SnackBar"
import formReggie from "./FormReggie"

const forbiddenSchemaValues = ["Number", "Text", "Yes or No", "Comments", "Date", "Time", "Signature", "Scanner", "ImageSketch"]
const forbiddenRequiredFields = ["StaticText", "Section"]

// const forbiddenSchemaValues = ["ImageSketch"]

const saveSetUp = {

    /* A function that takes in a form, template, userId, palette, newForm, and returnString. It then
    returns a formData object or stringified formData object. */
    setUpSave: (form: DynamicFormTypes, template: Array<Array<Array<FieldTypes>>> | [[]], userId: string | number, palette: Array<DynamicFormPaletteTypes>, auditSchema: boolean, newForm?: boolean, stringified?: boolean) => {
        const newTemplate = JSON.parse(JSON.stringify(template))//has to be done to avoid deep copies
        const customKeys = ["Position", "Formatter", "Validator", "ReferenceName", "LinkMap", "CustomDropDown"]//add custom config keys here
        let configTemplate: Array<Array<{ Validator: { type: any; }; Formatter: { type: any; }; ReferenceName: any; }>> | [[]] = []
        let formData = JSON.parse(JSON.stringify(form))//has to be done to avoid deep copies
        let fields: Array<FieldTypes> | any = []
        let ConfigField: FieldTypes = JSON.parse(JSON.stringify(schemaBoiler))
        ConfigField.Type = "Config"
        ConfigField.Name = "Config"
        let schemaDex = -1
        for (let i = 0; i < newTemplate.length; i++) {
            configTemplate.push(newTemplate[i])
            for (let j = 0; j < newTemplate[i].length; j++) {
                schemaDex++
                let field: FieldTypes | any = newTemplate[i][j]
                const Position = `${schemaDex}`
                const Formatter = { type: field.Formatter ? field.Formatter.type : null }
                const Validator = { type: field.Validator ? field.Validator.type : null }
                const ReferenceName = field.ReferenceName ? field.ReferenceName : null
                const LinkMap = field.LinkMap ? field.LinkMap : []
                const CustomDropDown = field.CustomDropDown || false
                const col = {
                    Position: Position,
                    Validator: Validator,
                    Formatter: Formatter,
                    ReferenceName: ReferenceName,
                    LinkMap: LinkMap,
                    CustomDropDown: CustomDropDown
                }
                configTemplate[i][j] = col
                fields.push({ ...schemaBoiler, ...field })
            }
        }

        ConfigField.Required = false
        ConfigField.CustomValues = [JSON.stringify(configTemplate)]
        ConfigField.CustomValues.push(JSON.stringify(paletteEngine.reducePalette(palette)))

        if (fields.length > 0 && fields[0].Type === "Config") {
            fields[0] = ConfigField
        } else {
            fields.unshift(ConfigField)
        }

        for (let i = 0; i < fields.length; i++) {
            for (let j = 0; j < customKeys.length; j++) {
                delete fields[i][customKeys[j]]
            }
        }

        formData.Fields = newForm ? [] : fields
        formData.FieldsSchema = newForm ? "[]" : JSON.stringify(fields)
        formData.Name = form.Name
        formData.CreatedBy = form.CreatedBy ? form.CreatedBy : userId
        formData.CreatedDate = form.CreatedDate ? form.CreatedDate : moment(Date.now().valueOf()).format()
        formData.ModifiedBy = userId
        formData.ModifiedDate = moment(Date.now().valueOf()).format()
        formData.CustomFormTypeId = form.CustomFormTypeId
        formData.CustomFormId = form.CustomFormId

        if (auditSchema) {

            let schema: FieldSchemaTypes[] = JSON.parse(formData.FieldsSchema)

            for (let i = 0; i < schema.length; i++) {
                let schemaItem = schema[i]

                if (forbiddenSchemaValues.indexOf(schemaItem.Type) > -1) {
                    schemaItem.Value = null
                }
                //!!! fix for bug 3001
                if ((forbiddenRequiredFields.indexOf(schemaItem.Type) > -1) && (schemaItem.Required)) {
                    schemaItem.Required = false
                    snackBar(
                        {
                            text: `The "Required" attribute for "${formReggie.deCamel(schemaItem.Type)}" fields is not allowed and has been removed from the form schema.`,
                            type: "info",
                            timeout: 10000
                        }
                    )
                }
            }

            formData.FieldsSchema = JSON.stringify(schema)
        }

        return stringified ? JSON.stringify(formData) : formData
    }
}
export default saveSetUp